// invitation-points.ts — Endpoints scoring d'invitation aux comités.
import { req } from './_internals.js';

export const invitationPointsApi = {
  getInvitationPoints: () => req('GET', '/invitation-points'),
  setInvitationPoint: (role: string, points: number | string) =>
    req('PUT', '/invitation-points/' + encodeURIComponent(role), { points }),
  computeInvitationPoints: (payload: unknown) => req('POST', '/invitation-points/compute', payload),
};
